exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".document {\n  padding: 20px;\n  background-color: #53b2e2;\n  color: white;\n  cursor: pointer; }\n  .document:hover {\n    background-color: #0f6d96; }\n  .document .document-name {\n    padding: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/communication/document-download/document-download.component.scss
// module id = ../../../../../src/app/communication/document-download/document-download.component.scss
// module chunks = main